(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementRotator extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.ann-slide'));
      if (this.slides.length <= 1) return;

      this.currentIndex = 0;
      this.speed        = (parseInt(this.dataset.speed) || 5) * 1000;
      this.transition   = this.dataset.transition || 'slide';
      this.isAutoplay   = this.dataset.autoplay === 'true';
      this.timer        = null;

      /* Pause autoplay in the Shopify theme editor for easier editing */
      if (window.Shopify && Shopify.designMode) this.isAutoplay = false;

      this.querySelector('.ann-btn--prev')
        ?.addEventListener('click', () => { this.go(-1); this.restart(); });
      this.querySelector('.ann-btn--next')
        ?.addEventListener('click', () => { this.go(1); this.restart(); });

      /* Pause on hover so visitors can read a message */
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => { if (this.isAutoplay) this.play(); });

      if (this.isAutoplay) this.play();
    }

    play() {
      this.stop();
      this.timer = setInterval(() => this.go(1), this.speed);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      if (this.isAutoplay) this.play();
    }

    go(dir) {
      const total     = this.slides.length;
      const prevIndex = this.currentIndex;
      const nextIndex = ((prevIndex + dir) % total + total) % total;

      const fromSlide = this.slides[prevIndex];
      const toSlide   = this.slides[nextIndex];

      if (this.transition === 'slide') {
        const enterFrom = dir > 0 ? '100%' : '-100%';
        const exitTo    = dir > 0 ? '-100%' : '100%';

        /* Position entering slide off-screen without animating */
        toSlide.style.transition  = 'none';
        toSlide.style.transform   = `translateX(${enterFrom})`;
        toSlide.style.opacity     = '1';
        toSlide.style.visibility  = 'visible';
        toSlide.offsetHeight; /* force reflow */

        /* Animate both slides simultaneously */
        toSlide.style.transition  = '';
        toSlide.style.transform   = 'translateX(0)';
        fromSlide.style.transform = `translateX(${exitTo})`;
        fromSlide.classList.add('ann-slide--leaving');
        toSlide.classList.add('ann-slide--active');

        fromSlide.addEventListener('transitionend', () => {
          fromSlide.classList.remove('ann-slide--active', 'ann-slide--leaving');
          fromSlide.style.transform  = '';
          fromSlide.style.opacity    = '';
          fromSlide.style.visibility = '';
          fromSlide.style.transition = '';
          fromSlide.setAttribute('aria-hidden', 'true');
          toSlide.style.opacity    = '';
          toSlide.style.visibility = '';
          toSlide.removeAttribute('aria-hidden');
        }, { once: true });

      } else {
        /* Fade: simply swap the active class; CSS transition handles opacity */
        fromSlide.classList.remove('ann-slide--active');
        fromSlide.setAttribute('aria-hidden', 'true');
        toSlide.classList.add('ann-slide--active');
        toSlide.removeAttribute('aria-hidden');
      }

      this.currentIndex = nextIndex;
    }
  }

  if (!customElements.get('announcement-rotator')) {
    customElements.define('announcement-rotator', AnnouncementRotator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
